import { API_ENDPOINT } from "@/utils/misc";
import axios from "axios";

export const getEmployeeTags = (from, until) => {
  return axios.get(`${API_ENDPOINT()}/employee-tags`, {
    params: { from, until },
  });
};
